
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "RSFNPN",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/RSFNPN.vue